/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserDataExportResponse
 */
export interface UserDataExportResponse {
    /**
     * 
     * @type {number}
     * @memberof UserDataExportResponse
     */
    exportId: number;
    /**
     * 
     * @type {string}
     * @memberof UserDataExportResponse
     */
    encryptionPassword: string;
}

/**
 * Check if a given object implements the UserDataExportResponse interface.
 */
export function instanceOfUserDataExportResponse(value: object): value is UserDataExportResponse {
    if (!('exportId' in value) || value['exportId'] === undefined) return false;
    if (!('encryptionPassword' in value) || value['encryptionPassword'] === undefined) return false;
    return true;
}

export function UserDataExportResponseFromJSON(json: any): UserDataExportResponse {
    return UserDataExportResponseFromJSONTyped(json, false);
}

export function UserDataExportResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserDataExportResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'exportId': json['exportId'],
        'encryptionPassword': json['encryptionPassword'],
    };
}

export function UserDataExportResponseToJSON(json: any): UserDataExportResponse {
    return UserDataExportResponseToJSONTyped(json, false);
}

export function UserDataExportResponseToJSONTyped(value?: UserDataExportResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'exportId': value['exportId'],
        'encryptionPassword': value['encryptionPassword'],
    };
}

